// src/pages/TestTypeTable.jsx
import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import Table from "../shared/table/Table";
import { FiEdit3, FiTrash2 } from "react-icons/fi";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const TestTypeTable = () => {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [testTypes, setTestTypes] = useState([]);


  // Listeyi çek
  const fetchTypes = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/test-types`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setTypes(data);
    } catch (err) {
      console.error("❌ Türler alınamadı:", err);
      toast.error("Türler alınamadı");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTypes();
  }, []);

  const [inUseMap, setInUseMap] = useState({});

useEffect(() => {
  if (!types.length) return;
  (async () => {
    const token = localStorage.getItem("admin_token");
    const results = await Promise.all(
      types.map(async (t) => {
        try {
          const { data } = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/test-types/${t.id}/in-use`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          return [t.id, !!data?.in_use];
        } catch {
          return [t.id, false];
        }
      })
    );
    setInUseMap(Object.fromEntries(results));
  })();
}, [types]);

const handleDelete = (id) => {
  confirmAlert({
    title: "Bu test türünü silmek istediğinize emin misiniz?",
    message: " Bu işlem geri alınamaz.",
    buttons: [
      {
        label: "Evet",
        onClick: async () => {
          try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/test-types/${id}`);
            toast.success("Test türü silindi");
            setTypes(prev => prev.filter(item => item.id !== id));
          } catch (err) {
            console.error("❌ Silme hatası:", err);
            toast.error("Silme sırasında bir hata oluştu");
          }
        }
      },
      {
        label: "Hayır",
        onClick: () => {}
      }
    ]
  });
};



  // Kolonlar
  const columns = useMemo(() => [
    { accessorKey: "id", header: "ID", size: 80 },
    { accessorKey: "name", header: "Başlık" },
    {
      accessorKey: "min_age",
      header: "Yaş Aralığı",
      cell: info => {
        const row = info.row.original;
        return `${row.min_age} - ${row.max_age}`;
      }
    },
    {
      accessorKey: "actions",
      header: "İşlemler",
      enableSorting: false,
      cell: info => {
        const row = info.row.original;
         const disabled = inUseMap[row.id];
        return (
          <div className="hstack gap-2 justify-content-end">
            <Link
              to={`/test-types/edit/${row.id}`}
              className="avatar-text avatar-md text-success bg-soft-success border-soft-success"
              title="Düzenle"
            >
              <FiEdit3 />
            </Link>
               <button
          onClick={() => !disabled && handleDelete(row.id)}
          disabled={disabled}
          className={`avatar-text avatar-md ${
            disabled
              ? "text-muted bg-light border-light"
              : "text-danger bg-soft-danger border-soft-danger"
          }`}
          title={disabled ? "Bu türe bağlı testler var, silinemez" : "Sil"}
        >
          <FiTrash2 />
        </button>
          </div>
        );
      }
    }
  ], [inUseMap]);

  return (
    <div className="container py-3">
      {loading ? (
        <p>Yükleniyor...</p>
      ) : (
        <Table data={types} columns={columns} />
      )}
    </div>
  );
};

export default TestTypeTable;
